module.exports = __webpack_public_path__ + "static/media/cw3.b1fabd53.png";